import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import MobileBottomNav from '../components/mobile/MobileBottomNav';
import BillingReadOnlyBanner from '../components/BillingReadOnlyBanner';
import { useUnreadCount } from '../hooks/useUnreadCount';

const AppLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const unreadCount = useUnreadCount();

  // ── Browser tab title reflects unread count in real-time ──────────────────
  useEffect(() => {
    document.title = unreadCount > 0
      ? `(${unreadCount > 99 ? '99+' : unreadCount}) CleanBid.ai`
      : 'CleanBid.ai';
  }, [unreadCount]);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar - Hidden on mobile */}
      <div className="hidden lg:block">
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      </div>

      {/* Main Content Area */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Header - Hidden on mobile */}
        <div className="hidden lg:block">
          <Header />
        </div>

        {/* Sprint C — SaaS billing read-only / billing-required banner.
            Renders only when the current tenant's canWrite=false and the
            user isn't already on a billing/pricing recovery page.
            Never blocks reads. */}
        <BillingReadOnlyBanner />

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden bg-gray-50 lg:p-6">
          {/* Add bottom padding on mobile for bottom nav.
              NOTE: do NOT add overflow-x-hidden / max-w-full here — pages like
              Inbox use `lg:-m-6` to escape the main padding on desktop, and
              clipping on this wrapper would cut 24px off the left edge. The
              horizontal overflow guard lives on <main> above, which is the
              correct boundary. */}
          <div className="lg:pb-0 pb-16">
            {children}
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation - Only visible on mobile */}
      <MobileBottomNav />
    </div>
  );
};

export default AppLayout;
